import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';

const Smarter = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');

    const list = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1756344040930/Frame%201612707768%20(2)%20(1).png',
            title: t('smarter_title1'),
            text: `smarter_text1`,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1755673485752/Frame%201612707768%20(1).png',
            title: t('smarter_title2'),
            text: `smarter_text2`,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1755673518231/Frame%201612707768%20(2).png',
            title: t('smarter_title3'),
            text: `smarter_text3`,
        },
    ];
    return (
        <div className={`${styles.smarter} GtmModuleData-section`} data-section-id={styles.smarter} data-section-title={t(`smarter_title`)}>
            <div className="text-container">
                <h2>{t(`smarter_title`)}</h2>
                <p className="intro">{t(`smarter_intro`)}</p>
            </div>
            <div className="content">
                <Swiper className="smarter-swiper" slidesPerView="auto" grabCursor spaceBetween={16}>
                    {list.map((item) => (
                        <SwiperSlide key={item.text} className="item">
                            <EFPicture src={item.img} alt={item.text} className="img" />
                            <div className="desc">
                                <div className="title">{item.title}</div>
                                {t.rich(item.text, {
                                    sup: (text: string) => <sup>{text}</sup>,
                                })}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default Smarter;
